const FLAG_KEY = "@meep/adyenForced";
const DEVICE_ID_OVERRIDE_KEY = "@meep/adyenDeviceIdOverride";

export const isAdyenForcedEnabled = (): boolean =>
  localStorage.getItem(FLAG_KEY) === "true";

export const setAdyenForcedEnabled = (enabled: boolean): void => {
  if (enabled) {
    localStorage.setItem(FLAG_KEY, "true");
  } else {
    localStorage.removeItem(FLAG_KEY);
  }
};

export const getAdyenDeviceIdOverride = (): string | null => {
  const value = localStorage.getItem(DEVICE_ID_OVERRIDE_KEY);
  return value?.trim() ? value.trim() : null;
};

export const setAdyenDeviceIdOverride = (deviceId: string | null): void => {
  if (deviceId?.trim()) {
    localStorage.setItem(DEVICE_ID_OVERRIDE_KEY, deviceId.trim());
  } else {
    localStorage.removeItem(DEVICE_ID_OVERRIDE_KEY);
  }
};
